<template>
  <div class="item" :class="userDetails.admin ? 'admin' : ''">
    <div class="user-id">{{ userDetails.id }}</div>
    <div class="name">{{ userDetails.name }}</div>
    <div class="username">{{ userDetails.username }}</div>
    <div class="email">{{ userDetails.email }}</div>
    <div class="phone-number">{{ userDetails.phoneNumber }}</div>
  </div>
</template>

<script>
export default {
  name: "UserAdminView",
  props: ["userDetails"],
};
</script>

<style lang="scss" scoped>
.admin {
  background-color: rgb(251, 240, 138);
}

.item {
  display: flex;
  flex-direction: column;
  padding: 15px 5px;
  margin: 0px 5px 5px 5px;
  border-bottom: 2px solid #000;
  //gap: 16px;

  @media (min-width: 800px) {
    flex-direction: row;
  }

  //border: 2px solid blue;

  .user-id {
    display: flex;
    justify-content: center;
    flex-basis: 20%;
  }

  .name {
    display: flex;
    justify-content: center;
    flex-basis: 25%;
  }

  .username {
    display: flex;
    justify-content: center;
    flex-basis: 15%;
  }

  .email {
    display: flex;
    justify-content: center;
    flex-basis: 20%;
  }

  .phone-number {
    display: flex;
    justify-content: center;
    flex-basis: 20%;
  }
}
</style>
